export const ThemeConfig = {
    dark: {
        mainColor: '#303030',
        contentColor: '#262525',
        fontColor: 'whitesmoke',
        underlineColor: 'rgba(212, 212, 212, 0.6)',
        pointColor: '#E05749',
        borderColor: '#3C3C3C',
        gridColor: 'rgba(128, 128, 128, 0.5)',
        gridBackgroundColor: '#262525',
        gridItemColor: '#303030',
        gridMapColor: '#303030',
        hoverColor: '#E05749',
        hoverFontColor: '#D4D4D4',
        buttonColor: '#EFEFEF',
        impactColor: 'green',
        menuHoverColor: '#d63e21',

        headerTextColor: '#ffffff',
        headerBackgroundColor: '#007bff',

        navigationFontColor: 'white',

        tableThFontColor: '#000000',
        tableThBackgroundColor: 'rgb(0, 42, 81)',
        tableHoverFontColor: '#000000',
        tableHoverBackgroundColor: 'whitesmoke',

        toolbarBackgroundColor: 'black',
        toolbarColor: 'white',
        toolbarSelectionColor: 'white',
        toolbarSelectionBackgroundColor: 'red',

        sidepopupBackgroundColor: '#0b172a',
        sidepopupHoverBackgroundColor: 'rgb(115, 118, 140)',
        sidepopupFontColor: 'silver',
        sidemenuBackgroundColor: '#2c446a',
        sidemenuHoverBackgroundColor: '#222f3e',

        dropdownMenuFontColor: '#a8a8a8',
        dropdownMenuHoverFontColor: 'white',

        selectedStateColor: '#374452',
        abnormalStateColor: 'brown',
        incompleteStateColor: 'steelblue',
        progressStateColor: 'lightcoral',
        completedStateColor: 'green',

        workflowBackground: 'white',
        workflowGrid: 'darkgray',

        normalBorder: 'black',
        startBorder: 'green',
        normalSelect: 'darkgray',
        startSelect: 'green',
        normalText: '#000000',
        startSelectText: '#ffffff',
        normalSelectText: 'black',
        normalBackground: '#ffffff',
        chainSelect: '#acac05',
        chainBackground: '#ffffff',

        stateDangerColor: '#dc3545',
        stateCriticalColor: '#e83e8c',
        stateWarningColor: '#fd7e14',
        stateMinorColor: '#ffc107',
        stateIndeterminateColor: '#6c757d',
        stateSuccessColor: '#28a745',
        statePrimaryColor: '#007bff',

        chartSeriesColors: {
            green: '#00bd88',
            yellow: '#fec53c',
            orange: '#ff6b25',
            silver: '#e7e7e7',
            navy: '#002d64',
        },

        managerHeaderBackground: '#535353',
        managerBackground: '#535353',

        readonlyInputColor: '#ffffff',
        readonlyInputBackgroundColor: '#2c2c2c',

        oddCommentBackgroundColor: '#424242',

        titleBorderColor: 'white',
        chatBot: {
          background: "#262626",
          border: "#3F3F3F",
          hover: "rgba(255, 255, 255, 0.08)",
          fontHeader: "#F7F7F7",
          font: "#EDEDED",
          blue: "#208FF5",
          shadow: "rgba(0, 0, 0, 0.20)",
          scroll: "#595959",
          tipBackground: "#181818",
          model: {
            background: "#3F3F3F",
            listBackground: "#3F3F3F",
            border: "#4F4F4F",
            font: "#EDEDED",
            info: "#C9C9C9"
          },
          list: {
            fontNew: "#F2F2F2",
            hover: "#303030",
            background: "#303030",
            dialogBorder: "#303030",
            dialogBackground: "#181818",
            dialogFont: "#DBDBDB"
          },
          input: {
            font: "#FFF",
            focus: "#1762AA",
            shadow: "rgba(0, 0, 0, 0.20)",
            placeholder: "#7F7F7F",
            fileIcon: "#DBDBDB",
            defaultIcon: "#FFF"
          },
          message: {
            background: "#303030",
            icon: "#FFF",
            border: "#262626",
            type: "#208FF5",
            number: "#FFF",
            numberBackground: "rgba(71, 143, 210, 0.40)",
            fileBorder: "#595959"
          },
          pdf: {
            button: "#C9C9C9",
            default: "rgba(71, 143, 210, 0.30)",
            defaultBorder: "#3D678D",
            progress: "#1762AA",
            uploadFont: "#A5A5A5",
            uploadHover: "rgba(71, 143, 210, 0.15)"
          },
          aifrica: {
            header: "#262626",
            font: "#DBDBDB",
            content: "#A5A5A5"
          }
        }
    },
    light: {
        mainColor: '#FFFFFF',
        contentColor: 'white',
        fontColor: '#000000',
        underlineColor: 'rgba(0, 0, 0, 0.6)',
        pointColor: '#007AAE',
        borderColor: '#5C5C5C',
        gridColor: 'rgba(0, 0, 0, 0.5)',
        gridBackgroundColor: 'rgb(225, 225, 225)',
        gridItemColor: 'white',
        gridMapColor: 'darkgray',
        hoverColor: '#007AAE',
        hoverFontColor: 'darkblue',
        buttonColor: '#D7D7D7',
        impactColor: 'rgba(128, 128, 128, 0.5)',
        menuHoverColor: '#003668',

        headerTextColor: '#ffffff',
        headerBackgroundColor: '#28a745',

        navigationFontColor: '#595959',

        tableThFontColor: '#000000',
        tableThBackgroundColor: '#F8F8F8',
        tableHoverFontColor: '#f6f6f6',
        tableHoverBackgroundColor: '#323232',

        toolbarBackgroundColor: 'white',
        toolbarColor: 'black',
        toolbarSelectionColor: 'rgb(33, 82, 245)',
        toolbarSelectionBackgroundColor: 'white',

        sidepopupBackgroundColor: 'rgb(57, 58, 66)',
        sidepopupHoverBackgroundColor: 'rgb(115, 118, 140)',
        sidepopupFontColor: 'silver',
        sidemenuBackgroundColor: '#323232',
        sidemenuHoverBackgroundColor: '#323232',

        dropdownMenuFontColor: '#7f7f7f',
        dropdownMenuHoverFontColor: '#003668',

        selectedStateColor: '#374452',
        abnormalStateColor: 'brown',
        incompleteStateColor: 'steelblue',
        progressStateColor: 'lightcoral',
        completedStateColor: 'green',

        workflowBackground: 'white',
        workflowGrid: 'darkgray',

        normalBorder: 'black',
        startBorder: 'green',
        normalSelect: 'darkgray',
        startSelect: 'green',
        normalText: '#000000',
        startSelectText: '#ffffff',
        normalSelectText: 'black',
        normalBackground: '#ffffff',
        chainSelect: '#acac05',
        chainBackground: '#ffff00',

        stateDangerColor: '#dc3545',
        stateCriticalColor: '#e83e8c',
        stateWarningColor: '#fd7e14',
        stateMinorColor: '#ffc107',
        stateIndeterminateColor: '#6c757d',
        stateSuccessColor: '#28a745',
        statePrimaryColor: '#007bff',

        chartSeriesColors: {
            green: '#00bd88',
            yellow: '#fec53c',
            orange: '#ff6b25',
            silver: '#e7e7e7',
            navy: '#002d64',
        },

        managerHeaderBackground: 'rgb(231, 241, 249)',
        managerBackground: 'lightgray',

        readonlyInputColor: '#7f7f7f',
        readonlyInputBackgroundColor: '#f2f2f2',

        oddCommentBackgroundColor: "#f9f9f9",

        titleBorderColor: 'black',
        chatBot: {
          background: "#FFFFFF",
          border: "#EDEDED",
          hover: "rgba(0, 0, 0, 0.03)",
          fontHeader: "#262626",
          font: "#595959",
          blue: "#006FD6",
          shadow: "rgba(0, 0, 0, 0.08)",
          scroll: "#DBDBDB",
          tipBackground: "#3F3F3F",
          model: {
            background: "#F7F7F7",
            listBackground: "#FFF",
            border: "#EDEDED",
            font: "#262626",
            info: "#A5A5A5"
          },
          list: {
            fontNew: "#595959",
            hover: "rgba(0, 0, 0, 0.03)",
            background: "#FFF",
            dialogBorder: "#EDEDED",
            dialogBackground: "#FFF",
            dialogFont: "#7F7F7F"
          },
          input: {
            font: "#262626",
            focus: "#006FD6",
            shadow: "rgba(0, 111, 214, 0.08)",
            placeholder: "#A5A5A5",
            fileIcon: "#595959",
            defaultIcon: "#006FD6"
          },
          message: {
            background: "#F7F7F7",
            icon: "#A5A5A5",
            border: "#F7F7F7",
            type: "#006FD6",
            number: "#006FD6",
            numberBackground: "#EDF5FD",
            fileBorder: "#7F7F7F"
          },
          pdf: {
            button: "#262626",
            default: "#EDF5FD",
            defaultBorder: "#DBEBFA",
            progress: "#006FD6",
            uploadFont: "#7F7F7F",
            uploadHover: "rgba(0, 111, 214, 0.07)"
          },
          aifrica: {
            header: "#E9E9E9",
            font: "#3F3F3F",
            content: "#7F7F7F"
          }
        }
    },
    dpg: {
        mainColor: '#FFFFFF',
        contentColor: 'white',
        fontColor: '#000000',
        underlineColor: 'rgba(0, 0, 0, 0.6)',
        pointColor: '#007AAE',
        borderColor: '#5C5C5C',
        gridColor: 'rgba(0, 0, 0, 0.5)',
        gridBackgroundColor: 'rgb(225, 225, 225)',
        gridItemColor: 'white',
        gridMapColor: 'darkgray',
        hoverColor: '#007AAE',
        hoverFontColor: 'darkblue',
        buttonColor: '#D7D7D7',
        impactColor: 'rgba(128, 128, 128, 0.5)',
        menuHoverColor: '#003668',

        headerTextColor: '#ffffff',
        headerBackgroundColor: '#28a745',

        navigationFontColor: '#595959',

        tableThFontColor: '#000000',
        tableThBackgroundColor: '#F8F8F8',
        tableHoverFontColor: '#f6f6f6',
        tableHoverBackgroundColor: '#323232',

        toolbarBackgroundColor: 'white',
        toolbarColor: 'black',
        toolbarSelectionColor: 'rgb(33, 82, 245)',
        toolbarSelectionBackgroundColor: 'white',

        sidepopupBackgroundColor: 'rgb(57, 58, 66)',
        sidepopupHoverBackgroundColor: 'rgb(115, 118, 140)',
        sidepopupFontColor: 'silver',
        sidemenuBackgroundColor: '#323232',
        sidemenuHoverBackgroundColor: '#323232',

        dropdownMenuFontColor: '#7f7f7f',
        dropdownMenuHoverFontColor: '#003668',

        selectedStateColor: '#374452',
        abnormalStateColor: 'brown',
        incompleteStateColor: 'steelblue',
        progressStateColor: 'lightcoral',
        completedStateColor: 'green',

        workflowBackground: 'white',
        workflowGrid: 'darkgray',

        normalBorder: 'black',
        startBorder: 'green',
        normalSelect: 'darkgray',
        startSelect: 'green',
        normalText: '#000000',
        startSelectText: '#ffffff',
        normalSelectText: 'black',
        normalBackground: '#ffffff',
        chainSelect: '#acac05',
        chainBackground: '#ffff00',

        stateDangerColor: '#dc3545',
        stateCriticalColor: '#e83e8c',
        stateWarningColor: '#fd7e14',
        stateMinorColor: '#ffc107',
        stateIndeterminateColor: '#6c757d',
        stateSuccessColor: '#28a745',
        statePrimaryColor: '#007bff',

        chartSeriesColors: {
            green: '#00bd88',
            yellow: '#fec53c',
            orange: '#ff6b25',
            silver: '#e7e7e7',
            navy: '#002d64',
        },

        managerHeaderBackground: 'rgb(231, 241, 249)',
        managerBackground: 'lightgray',

        readonlyInputColor: '#7f7f7f',
        readonlyInputBackgroundColor: '#f2f2f2',

        oddCommentBackgroundColor: '#f9f9f9',

        titleBorderColor: 'black',
        chatBot: {
          background: "#FFFFFF",
          border: "#EDEDED",
          hover: "rgba(0, 0, 0, 0.03)",
          fontHeader: "#262626",
          font: "#595959",
          blue: "#006FD6",
          shadow: "rgba(0, 0, 0, 0.08)",
          scroll: "#DBDBDB",
          tipBackground: "#3F3F3F",
          model: {
            background: "#F7F7F7",
            listBackground: "#FFF",
            border: "#EDEDED",
            font: "#262626",
            info: "#A5A5A5"
          },
          list: {
            fontNew: "#595959",
            hover: "rgba(0, 0, 0, 0.03)",
            background: "#FFF",
            dialogBorder: "#EDEDED",
            dialogBackground: "#FFF",
            dialogFont: "#7F7F7F"
          },
          input: {
            font: "#262626",
            focus: "#006FD6",
            shadow: "rgba(0, 111, 214, 0.08)",
            placeholder: "#A5A5A5",
            fileIcon: "#595959",
            defaultIcon: "#006FD6"
          },
          message: {
            background: "#F7F7F7",
            icon: "#A5A5A5",
            border: "#F7F7F7",
            type: "#006FD6",
            number: "#006FD6",
            numberBackground: "#EDF5FD",
            fileBorder: "#7F7F7F"
          },
          pdf: {
            button: "#262626",
            default: "#EDF5FD",
            defaultBorder: "#DBEBFA",
            progress: "#006FD6",
            uploadFont: "#7F7F7F",
            uploadHover: "rgba(0, 111, 214, 0.07)"
          },
          aifrica: {
            header: "#E9E9E9",
            font: "#3F3F3F",
            content: "#7F7F7F"
          }
        }
    }
  };
